const moment = require('moment');

/**
 * Jackpot Skin Mapping class.
 *
 * @class
 * @returns {string} Skin name.
 **/

class JackpotSkinMapping{
    static networkSkinMapping(){
        let skin = '';
        let today = new Date();
        let dateToCompare =  '2020-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');

        if (moment(dateToCompare).isBetween('2020-02-03', '2020-02-16', [], [])) skin = 'networkValentine';
        else if (moment(dateToCompare).isBetween('2020-03-10', '2020-03-21', [], [])) skin = 'networkStPatrick';
        else if (moment(dateToCompare).isBetween('2020-03-29', '2020-04-20', [], [])) skin = 'networkEaster';
        else if (moment(dateToCompare).isBetween('2020-06-01', '2020-08-31', [], [])) skin = 'networkSummer';
        else if (moment(dateToCompare).isBetween('2020-10-17', '2020-10-31', [], [])) skin = 'networkHalloween';
        else if (moment(dateToCompare).isBetween('2020-12-01', '2020-12-31', [], [])) skin = 'networkChristmas';
        else if (moment(dateToCompare).isBetween('2020-01-01', '2020-01-08', [], [])) skin = 'networkChristmas';
        else skin = 'network';

        return skin;
    }
}
module.exports = JackpotSkinMapping;